import { render, staticRenderFns } from "./CandidateItemRemoveFromQueue.vue?vue&type=template&id=64fbb76e&lang=pug"
import script from "./CandidateItemRemoveFromQueue.vue?vue&type=script&lang=js"
export * from "./CandidateItemRemoveFromQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports